import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DespesaService } from '../despesa-service/despesa.service';
import { ConversaoLibraConverte } from '././../../../../shared/conversao-libra/conversao-libra-converte';
import { ListaBase } from '././../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from '././../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-despesa-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./despesa-lista.component.css']
})
export class DespesaListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;
  subscription;

  constructor(service: DespesaService, 
    toastr: ToastrService, 
    router: Router,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna("nome_dealer", 'Dealer')
      .addColuna("nome_categoria_despesa", 'parametros.despesa.categoriaDespesa')
      .addColuna("ano", 'parametros.despesa.ano')
      .addColuna("mes", 'parametros.despesa.mes')
      .addColuna("valor", 'parametros.despesa.valor')
      .build();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
          this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.id_dealer
      || this.filtros.id_categoria_despesa
      || this.filtros.valor
      || this.filtros.mes
      || this.filtros.ano;
  }

  getDados(response: any): any {

    response.dados.forEach(element => {
      element.valor = this.conversaoLibraConverte.conversaoLibra(element.valor, null, null).toFixed(2);
    });

    return response.dados;
  }

}
